(function() {
  angular
    .module('specsguardApp')
    .directive('sgTableDateFilter', sgTableDateFilter);

  sgTableDateFilter.$inject = [];

  function sgTableDateFilter() {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-mat-table/sg-table-date-filter/sg-table-date-filter.html'
    }
  };
})();
